import { useEffect, useState } from "react";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../core/services/dataBean/useDataBean"
import { BasicPage } from "../theme/Component/BasicPage"
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import usePaginator from "../theme/Component/usePaginator";
import { SelectBudgetTypes } from "../erp/cellEditor/AccountantConcept/SelectBudgetTypes";
import { SelectBudgetType } from "../admin/configuracion/select/SelectBudgetType";
import { SelectBudgetResource } from "../contract/select/SelectBudgetResource";
import { SelectBudgetSource } from "../admin/configuracion/BudgetSource/SelectBudgetSource";
import { SelectBudgetID } from "../admin/configuracion/BudgetID/SelectBudgetID";
import { BasicButton } from "../theme/Component/BasicButton";
import { SelectMonths } from "../contract/select/SelectMonths";
import { BasicTable, MASK_MONEY } from "../theme/Component/BasicTable";

export const BudgetReportExecution = () => {

    const _budget = useDataBean(_BudgetID);
    const { lista, setLista, bean, setBean } = _budget;

    const [data, setData] = useState<any>({});
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [month, setMonth] = useState<number>(1);
    const [type, setType] = useState<number>(26);
    const paginador = usePaginator();


    const getBudgetByMonth = () => {
        let filter = {
            IDBudgetResource:data.IDBudgetResource,
            IDBudgetSource:data.IDBudgetSource
        }
        _budget.instance.getBudgetByMonth(year, month, 1, 15, filter).then(
            (resp: any) => {
                setLista(resp.List);
            }
        )
    }

    const head25 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'BudgetName', visible: true },
        { title: 'Recurso', property: 'NameResource', visible: true },
        { title: 'Fuente', property: 'NameSource', visible: true },
        // { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        // { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },
        // { title: 'RCDP', property: 'RCDPValue', visible: true, mask: MASK_MONEY },
        { title: 'CDP', property: 'CDPValue', visible: true, mask: MASK_MONEY },
        { title: 'RP', property: 'RPValue', visible: true, mask: MASK_MONEY },
        { title: 'OB    ', property: 'OBValue', visible: true, mask: MASK_MONEY },
        // {title:'OB',property:'OBValue',visible:true,mask:MASK_MONEY},
        // {title:'CE',property:'CEValue',visible:true,mask:MASK_MONEY},

    ]
    const head26 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'NameBudget', visible: true },
        { title: 'Recurso', property: 'NameBudgetResource', visible: true },
        { title: 'Fuente', property: 'NameBudgetSource', visible: true },
        { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },

        { title: 'IAD', property: 'IADValue', visible: true, mask: MASK_MONEY },
        { title: 'AP', property: 'APValue', visible: true, mask: MASK_MONEY },
    ]

    return (
        <BasicPage titulo="Ejecucion presupuestal Rubro">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-2">
                    <SelectMonths label="Mes" idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetTypes label="Tipo Presupuesto" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetType idType={type} idSelector={data.IDBudgetType} onChange={(e) => { setData({ ...data, "IDBudgetType": parseInt(e) }) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetResource idSelector={data.IDBudgetResource} onChange={(e) => { setData({ ...data, "IDBudgetResource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetSource idSelector={data.IDBudgetSource} onChange={(e) => { setData({ ...data, "IDBudgetSource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-4">
                    <SelectBudgetID jsonCode={data.BudgetIDStr} onChange={(e) => { setData({ ...data, "BudgetIDStr": e.JsonCode }) }} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 mt-3">
                    <BasicButton icon="" eventClick={getBudgetByMonth}>Buscar</BasicButton>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable  head={type == 25 ? head26 : head25} body={lista} rowSet={setBean} 
                    // pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                    ></BasicTable>
                </div>
            </div>
        </BasicPage>
    )
}
